export default function Select({
  options,
  value,
  setValue,
  label,
  name = label,
}) {
  return (
    <>
      {label && (
        <label
          for={name}
          className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
        >
          {label}
        </label>
      )}

      <select
        value={value}
        onChange={(event) => setValue(event.target.value)}
        id={name}
        className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
      >
        {options.map((option) => (
          <option value={option.value} selected={option.value == value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
}
